import * as React from 'react'
import { IconComponent } from 'design-system/types'

export const SortDown: IconComponent = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 6"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M7.717.79c-.2-.2-.45-.29-.71-.29H1.003c-.26 0-.51.09-.71.29-.39.39-.39 1.03 0 1.42l3.002 3c.39.39 1.02.39 1.41 0l3.002-3c.39-.39.39-1.03 0-1.42h.01z" />
    </svg>
  )
}
